// import RouterPage from './pages/FrontPage/RouterPage';
// import "./App.css";

// function App() {
//         return (
//                 <div >
//                         <RouterPage />
//                 </div>
//         );
// }
// export default App;

import RouterPage from './pages/FrontPage/RouterPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";

function App() {
    return (
        <div>
            <RouterPage />
            <ToastContainer position="top-center" autoClose={5000} />
        </div>
    );
}

export default App;

